import {CYCLE_PERIOD_SECONDS, TICKET_CHUNK_SIZES} from "@/components/devices/Infoscreen/config";

export default {
  data() {
    return {
      currentIndex: 0,
      cyclingInterval: null,
      hidden: false,
    }
  },
  computed: {
    cyclePeriod() {
      return (CYCLE_PERIOD_SECONDS[this.$options.name] * 1000) || 6000;
    },
    chunkLength() {
      return TICKET_CHUNK_SIZES[this.$options.name] || 6;
    },
    list() {
      return this.tickets.reduce((acc, item, index) => {
        const chunkIndex = Math.floor(index / this.chunkLength);

        if (!acc[chunkIndex]) {
          acc[chunkIndex] = [];
        }

        item && acc[chunkIndex].push(item);

        return acc;
      }, []);
    }
  },
  mounted() {
    this.startCycling();
  },
  beforeDestroy() {
    this.cyclingInterval && clearInterval(this.cyclingInterval);
  },
  methods: {
    startCycling() {
      this.cyclingInterval = setInterval(() => {
        this.cycleTicket();
      }, this.cyclePeriod);
    },
    cycleTicket() {
      // Prevent cycling animation if there is only one chunk to be shown
      const nextElementIndex = this.getNextElementIndex();
      if (this.currentIndex === nextElementIndex) return;

      // Cycle through chunks
      this.hidden = true;
      setTimeout(() => {
        this.currentIndex = nextElementIndex;
        this.hidden = false;
      }, 500);
    },
    getNextElementIndex() {
      if (!this.list || !this.list.length) return 0;

      return this.currentIndex + 1 < this.list.length ? this.currentIndex + 1 : 0;
    }
  }
}
